__turbopack_context__.v({
  "description": "NoForumActivity-module-scss-module__5N6hLa__description",
  "link": "NoForumActivity-module-scss-module__5N6hLa__link",
  "root": "NoForumActivity-module-scss-module__5N6hLa__root",
  "title": "NoForumActivity-module-scss-module__5N6hLa__title",
});
